import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartsResponse } from './multiCartMappers'
import { arrayToObject } from 'lib/array/arrayUtils'
import qs from 'qs'

type FetchSuccess = paths['/api/carts/multi-carts']['get']['responses']['200']['content']['application/json']

export async function getMultiCartSummaries(input: { isSharedCartsFeatureEnabled: boolean, isSharedCartInvitePage: boolean }): Promise<MachineContext.CartSummary> {
  const checkExistingOnly = !input.isSharedCartsFeatureEnabled && !input.isSharedCartInvitePage
  const queryParams = qs.stringify({ checkExistingOnly: checkExistingOnly ? 'true' : 'false' })

  const response = await request.get<FetchSuccess>(`/api/carts/multi-carts?${queryParams}`, { credentials: 'include' })
  const cartSummaries = mapMultiCartsResponse(response)

  return arrayToObject(cartSummaries, item => item.cartId) as MachineContext.CartSummary
}
